<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Payment Recieve</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item">Operation</li>
                  <li class="breadcrumb-item active">Payment Recieve</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <!-- Create New -->
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-body">
                  <form class="needs-validation" novalidate="">
                    <div class="row g-3">
                      <div class="col-md-4">
                        <label class="form-label" for="name">Customer</label>
                        <Select2 :options="customer_list" @select="onCustomerSelect($event)" />

                        <!-- <select class="form-control" id="customer" name="customer" @change="onCustomerSelect">
                          <option value="">Select Customer</option>
                          <option v-for="(cc, i) in customer_list" :key="{ i }" :value="cc.id"
                            :selected="this.customer_id === cc.id">
                            {{ cc.name }} ( {{ cc.customer_id }} )
                          </option>
                        </select> -->
                      </div>
                      <div class="col-md-4">
                        <label class="form-label" for="name">Unpaid Invoice</label>
                        <select class="form-control" id="customer" name="customer" @change="onInvSelect">
                          <option value="">Select Invoice</option>
                          <option v-for="(cc, i) in invoice_list" :key="{ i }" :value="cc.id"
                            :selected="this.invoice_id === cc.id">
                            {{ cc.inv_no }} ( {{ cc.inv_due_amount }} Tk)
                          </option>
                        </select>
                      </div>
                      <div class="col-md-4">
                        <label class="form-label" for="name">MR Number</label>
                        <input v-model="mr_number" class="form-control" id="color" type="text"
                          placeholder="Enter MR Number" aria-describedby="inputGroupPrepend" required="" />
                      </div>
                      <div class="col-md-4">
                        <label class="form-label" for="name">Recieve Date</label>
                        <input v-model="receive_date" class="form-control" id="color" type="date"
                          aria-describedby="inputGroupPrepend" required="" />
                      </div>
                      <div class="col-md-4">
                        <label class="form-label" for="color">MR Date</label>
                        <input v-model="mr_date" class="form-control" id="color" type="date"
                          aria-describedby="inputGroupPrepend" required="" />
                      </div>
                      <div class="col-md-4">
                        <label class="form-label" for="name">Payment Method</label>
                        <select class="form-control" id="customer" name="customer" v-model="payment_method">
                          <option value="">Select method</option>
                          <option value="1">Cash</option>
                          <option value="2">Bank</option>
                          <option value="3">bKash</option>
                          <option value="4">Chalan</option>
                        </select>
                      </div>
                      <!-- Bank -->
                      <div class="col-md-4" v-if="payment_method == 2">
                        <label class="form-label" for="name">Bank Name</label>
                        <input v-model="bank_name" class="form-control" id="color" type="text"
                          placeholder="Enter Bank Name" aria-describedby="inputGroupPrepend" required="" />
                      </div>
                      <div class="col-md-4" v-if="payment_method == 2">
                        <label class="form-label" for="name">Bank Branch</label>
                        <input v-model="bank_branch" class="form-control" id="color" type="text"
                          placeholder="Enter Bank Branch" aria-describedby="inputGroupPrepend" required="" />
                      </div>
                      <div class="col-md-4" v-if="payment_method == 2">
                        <label class="form-label" for="name">Cheque Number</label>
                        <input v-model="cheque_number" class="form-control" id="color" type="text"
                          placeholder="Enter Cheque Number" aria-describedby="inputGroupPrepend" required="" />
                      </div>
                      <div class="col-md-4" v-if="payment_method == 2">
                        <label class="form-label" for="name">Cheque Date</label>
                        <input v-model="cheque_date" class="form-control" id="color" type="date"
                          placeholder="Enter Cheque Date" aria-describedby="inputGroupPrepend" required="" />
                      </div>
                      <!-- Bkash -->
                      <div class="col-md-4" v-if="payment_method == 3">
                        <label class="form-label" for="name">Bkash Date</label>
                        <input v-model="bkash_date" class="form-control" id="color" type="date" placeholder="Enter Date"
                          aria-describedby="inputGroupPrepend" required="" />
                      </div>
                      <div class="col-md-4" v-if="payment_method == 3">
                        <label class="form-label" for="name">Transaction ID</label>
                        <input v-model="bkash_transaction_id" class="form-control" id="color" type="text"
                          placeholder="Enter Transaction Number" aria-describedby="inputGroupPrepend" required="" />
                      </div>
                      <div class="col-md-4" v-if="payment_method == 3">
                        <label class="form-label" for="name">Reference</label>
                        <input v-model="bkash_transfer_reference" class="form-control" id="color" type="text"
                          placeholder="Enter Transaction Reference" aria-describedby="inputGroupPrepend" required="" />
                      </div>

                      <div class="col-md-4" v-if="payment_method == 4">
                        <label class="form-label" for="name">Chalan No</label>
                        <input v-model="chalan_no" class="form-control" id="color" type="text"
                          placeholder="Enter Chalan No" aria-describedby="inputGroupPrepend" required="" />
                      </div>

                      <!--  -->
                      <div class="col-md-4">
                        <label class="form-label" for="name">Amount</label>
                        <input v-model="amount" class="form-control" id="color" type="number" placeholder="Enter Amount"
                          aria-describedby="inputGroupPrepend" required="" />
                      </div>
                      <div class="col-md-4">
                        <label class="form-label" for="name">Note</label>
                        <textarea v-model="note" class="form-control" id="color" type="text" placeholder="Enter Note"
                          aria-describedby="inputGroupPrepend" required="" />
                      </div>
                    </div>
                    <button class="btn btn-primary mt-3" type="button" @click="recievePayment">
                      Recieve Payment
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
      </div>
    </div>
  </div>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

import customerAPI from "../../services/customer.API";
import invoiceAPI from "../../services/invoice.API";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Select2 from "vue3-select2-component";

export default {
  name: "employeeList",
  components: {
    Select2
  },
  data() {
    return {
      customer_id: "",
      customer_list: [],
      service_list: [],
      invoice_id: "",
      mr_number: "",
      receive_date: moment(new Date()).format("yyyy-MM-DD"),
      mr_date: moment(new Date()).format("yyyy-MM-DD"),
      payment_method: "",
      bank_name: "",
      bank_branch: "",
      cheque_number: "",
      cheque_date: moment(new Date()).format("yyyy-MM-DD"),
      bkash_date: moment(new Date()).format("yyyy-MM-DD"),
      bkash_transaction_id: "",
      bkash_transfer_reference: "",
      chalan_no: "",
      amount: "",
      note: "",
      invoice_list: [],
    };
  },
  methods: {
    // on customer select
    onCustomerSelect(e) {

      e.target = {
        "value": e.id
      };

      this.customer_id = Number(e.target.value);
      if (e.target.value) {
        let data = {
          customer_id: Number(e.target.value),
        };

        // get service list by Customer ID
        customerAPI.getServiceList(data).then((res) => {
          this.service_list = res.data.data
            // .map((e) => e.isAssigned === true)
            .filter(function (n) {
              return (n || n === 0) && n.isAssigned === true;
            });
        });

        // get invoice list
        let customerData = {
          customer_id: Number(e.target.value)
        }
        customerAPI.invoiceList(customerData).then((res) => {
          // console.log(res);
          if (res?.data?.data) {
            this.invoice_list = res.data.data.invoiceData
          }

          if(this.invoice_list.length == 0) {
            this.invoice_list = [ { "inv_no" : "Advance Payment",   "inv_due_amount" : "_" , "id" : -1 }]
          }

          
        });
      }
    },

    // INV select
    onInvSelect(e) {
      this.invoice_id = Number(e.target.value);
    },
    // clear
    clearState() {
      this.customer_id = "";
      this.service_list = [];
      this.invoice_id = "";
      this.mr_number = "";
      this.receive_date = "";
      this.mr_date = "";
      this.invoice_list = [];
      this.payment_method = "";
      this.bank_name = "";
      this.bank_branch = "";
      this.cheque_number = "";
      this.cheque_date = "";
      this.bkash_date = "";
      this.bkash_transaction_id = "";
      this.bkash_transfer_reference = "";
      this.chalan_no = "";
      this.amount = "";
      this.note = "";
    },
    //recievePayment
    recievePayment() {
      if (this.payment_method == '2') {
        let data = {
          customer_id: this.customer_id,
          invoice_id: this.invoice_id,
          mr_number: this.mr_number,
          receive_date: this.receive_date,
          mr_date: this.mr_date,
          payment_method: this.payment_method,
          bank_name: this.bank_name,
          bank_branch: this.bank_branch,
          cheque_number: this.cheque_number,
          cheque_date: this.cheque_date,
          amount: this.amount,
          note: this.note,
        };

        invoiceAPI.paymentRecieve(data).then(
          (res) => {
            if (res?.data?.success === true) {
              this.$moshaToast(res.data.message, {
                type: "success",
                position: "top-right",
                showIcon: true,
              });
              this.downloadPDFPaymentInvoice(res?.data?.data);
              this.clearState()
            }
          },
          (err) => {
            if (err?.response?.data?.success === false) {
              this.$moshaToast(err.response.data.message, {
                type: "danger",
                position: "top-right",
                showIcon: true,
              });
            }
          }
        );
      } else if (this.payment_method == '3') {
        let data = {
          customer_id: this.customer_id,
          invoice_id: this.invoice_id,
          mr_number: this.mr_number,
          receive_date: this.receive_date,
          mr_date: this.mr_date,
          payment_method: this.payment_method,
          bkash_date: this.bkash_date,
          bkash_transaction_id: this.bkash_transaction_id,
          bkash_transfer_reference: this.bkash_transfer_reference,
          amount: this.amount,
          note: this.note,
        };

        invoiceAPI.paymentRecieve(data).then(
          (res) => {
            if (res?.data?.success === true) {
              this.$moshaToast(res.data.message, {
                type: "success",
                position: "top-right",
                showIcon: true,
              });

              this.downloadPDFPaymentInvoice(res?.data?.data);
              this.clearState()
            }
          },
          (err) => {
            if (err?.response?.data?.success === false) {
              this.$moshaToast(err.response.data.message, {
                type: "danger",
                position: "top-right",
                showIcon: true,
              });
            }
          }
        );
      } else if (this.payment_method == '4') {
        let data = {
          customer_id: this.customer_id,
          invoice_id: this.invoice_id,
          mr_number: this.mr_number,
          receive_date: this.receive_date,
          mr_date: this.mr_date,
          payment_method: this.payment_method,
          chalan_no: this.chalan_no,
          amount: this.amount,
          note: this.note,
        };

        invoiceAPI.paymentRecieve(data).then(
          (res) => {
            if (res?.data?.success === true) {
              this.$moshaToast(res.data.message, {
                type: "success",
                position: "top-right",
                showIcon: true,
              });

              this.downloadPDFPaymentInvoice(res?.data?.data);
              this.clearState()
            }
          },
          (err) => {
            if (err?.response?.data?.success === false) {
              this.$moshaToast(err.response.data.message, {
                type: "danger",
                position: "top-right",
                showIcon: true,
              });
            }
          }
        );
      } else {
        let data = {
          customer_id: this.customer_id,
          invoice_id: this.invoice_id,
          mr_number: this.mr_number,
          receive_date: this.receive_date,
          mr_date: this.mr_date,
          payment_method: this.payment_method,
          amount: this.amount,
          note: this.note,
        };
        invoiceAPI.paymentRecieve(data).then(
          (res) => {
            if (res?.data?.success === true) {
              this.$moshaToast(res.data.message, {
                type: "success",
                position: "top-right",
                showIcon: true,
              });

              this.downloadPDFPaymentInvoice(res?.data?.data);
              this.clearState()
            }
          },
          (err) => {
            if (err?.response?.data?.success === false) {
              this.$moshaToast(err.response.data.message, {
                type: "danger",
                position: "top-right",
                showIcon: true,
              });
            }
          }
        );
      }
    },

    async downloadPDFPaymentInvoice(item) {
      let converter = require('number-to-words');

      let customerName = "";
      try {
        let customerDetails = await customerAPI.getDetails(item.customer_id);
        if (customerDetails.data.success) {
          customerName = customerDetails.data.data.name;
        }
      } catch (error) { customerName = ""; }



      let today = moment(new Date()).format("DD MMMM, YYYY  h:mm a");
      let payment_method = item.payment_method == 1 ? "CASH" : (item.payment_method == 2) ? "BANK" : (item.payment_method == 3) ? "BKash" : "Chalan";
      let amount_tk_word = converter.toWords(item.amount);

      let data = {
        "invoice_no": item.id.toString(),
        "customer_name": customerName,
        "mr_number": item.mr_number,
        "mr_date": moment(item.mr_date).format("MMMM DD, YYYY"),
        "received_date": moment(item.receive_date).format("MMMM DD, YYYY"),
        "amount_tk": item.amount,
        "amount_tk_word": amount_tk_word + " tk only",
        "payment_method": payment_method,
        "note": item.note,
        "bkash_date": moment(item.bkash_date).format("MMMM DD, YYYY"),
        "transection_id": item.bkash_transaction_id,
        "reference": item.bkash_transfer_reference,
        "bank_name": item.bank_name,
        "bank_branch": item.bank_branch,
        "cheque_number": item.cheque_number,
        "cheque_date": moment(item.cheque_date).format("MMMM DD, YYYY"),
        "chalan_no": item.chalan_no,
        "copy_right_message": "This is system generated invoice no signature required. Invoice Print Date: " + today
      };

      var doc = new jsPDF("p", "pt", "a4", true);

      doc.setFontSize(40);

      let tempMisHight = 65;
      let tempMisWidth = 40;

      var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

      doc.setFontSize(20);
      doc.text("INFOCOM LIMITED", tempMisWidth + 260, tempMisHight + 25, { align: "center" });

      var img = new Image();
      img.src = 'images/sample.png';
      doc.addImage(img, 'png', pageWidth - 100, 30, 80, 35);

      // this.setPrintText(doc, "HEAD OFFICE: ", tempMisWidth + 100, tempMisHight + 45, "bold", 10);
      // this.setPrintText(doc, "Udoy Tower, (9th floor), Plot # 57 & 57/A, Gulshan Avenue, Dhaka 1212", tempMisWidth + 298, tempMisHight + 45, "normal", 56);
      // this.setPrintText(doc, "Tel: 88-02-9860906, 88-02-8816282, 99-028837430-33, 88-02-9892169, Cell: +88 0181941241 ", tempMisWidth + 260, tempMisHight + 58, "normal", 56);
      // this.setPrintText(doc, "E-mail: info@aktelecom.net; help@aktelecom.net; Web: www.aktelecom.net", tempMisWidth + 260, tempMisHight + 71, "normal", 56);

      doc.setFontSize(6);
      this.setPrintText(doc, "Corporate Office: Uday tower, (9th floor), Plot # 57 & 57/A, Gulshan Avenue, Dhaka-1212.IP Phone: +88-9614224466", tempMisWidth + 265, tempMisHight + 45, "bold", 10);
      this.setPrintText(doc, "Cell: +88-01819412413, Tel: +88-02222299603, +88-02222292169, +88-02222287485, +88-029887485", tempMisWidth + 270, tempMisHight + 56, "normal", 56);
      this.setPrintText(doc, "Head Office: Batali Hills, Ambagan, Chattogram -4000, Tel: +88-02 333351050-51", tempMisWidth + 260, tempMisHight + 67, "normal", 56);
      this.setPrintText(doc, "E-mail: info@aktelecom.net; help@aktelecom.net; Web: www.aktelecom.net", tempMisWidth + 260, tempMisHight + 78, "normal", 56);


      doc.setFontSize(10);
      doc.text(`MR Number: ${data.mr_number}`, (tempMisWidth + 10), tempMisHight + 135, { align: "left" });
      doc.text(`Payment By: ${data.payment_method}`, (tempMisWidth + 10), tempMisHight + 148, { align: "left" });

      doc.setFontSize(14);
      doc.text("OFFICIAL RECEIPT", tempMisWidth + 245, tempMisHight + 140, { align: "center" });

      doc.setFontSize(10);
      doc.text(`Received Date: ${data.received_date}`, (tempMisWidth + 380), tempMisHight + 135, { align: "left" });
      doc.text(`MR Date: ${data.mr_date}`, (tempMisWidth + 380), tempMisHight + 148, { align: "left" });


      doc.text(`Amount Tk: ${data.amount_tk}`, (tempMisWidth + 10), tempMisHight + 185, { align: "left" });
      doc.text(`In Word: ${data.amount_tk_word}`, (tempMisWidth + 220), tempMisHight + 185, { align: "left" });

      // if(data.payment_method == "CASH") {} else 

      if (data.payment_method == "BKash") {
        doc.text(`bKash Date: ${data.bkash_date}`, (tempMisWidth + 10), tempMisHight + 200, { align: "left" });
        doc.text(`Transection ID: ${data.transection_id}`, (tempMisWidth + 180), tempMisHight + 200, { align: "left" });
        doc.text(`Reference: ${data.reference}`, (tempMisWidth + 330), tempMisHight + 200, { align: "left" });

      } else if (data.payment_method == "Chalan") {
        doc.text(`Chalan No: ${data.chalan_no}`, (tempMisWidth + 10), tempMisHight + 200, { align: "left" });

      } else if (data.payment_method == "BANK") {
        doc.text(`Bank Name: ${data.bank_name}`, (tempMisWidth + 10), tempMisHight + 200, { align: "left" });
        doc.text(`Bank Branch: ${data.bank_branch}`, (tempMisWidth + 220), tempMisHight + 200, { align: "left" });
        doc.text(`Cheque No: ${data.cheque_number}`, (tempMisWidth + 10), tempMisHight + 215, { align: "left" });
        doc.text(`Cheque Date: ${data.cheque_date}`, (tempMisWidth + 220), tempMisHight + 215, { align: "left" });
      }

      doc.text(`Customer Name: ${data.customer_name}`, (tempMisWidth + 10), tempMisHight + 230, { align: "left" });
      doc.text(`This Receipt is valid only when signed by an authorized officer or a Rubber stamp.`, (tempMisWidth + 10), tempMisHight + 260, { align: "left" });
      doc.text(`Note: ${data.note}`, (tempMisWidth + 10), tempMisHight + 272, { align: "left" });
      doc.text(`Authorized Signature.`, (tempMisWidth + 395), tempMisHight + 325, { align: "center" });
      doc.text(`_____________________________`, (tempMisWidth + 315), tempMisHight + 308, { align: "left" });

      doc.text(data.copy_right_message, (tempMisWidth + 230), pageHeight - 10, { align: "center" });

      doc.save(`Payment invoice No ${data.invoice_no}.pdf`);

      // Auto print code
      doc.autoPrint();
      try {
        window.open(doc.output("bloburl"), "_blank");
      } catch (e) {
        console.log(e);
      }

    },

    setPrintText(
      doc = undefined,
      text = "",
      widthPosition = 0,
      heightPosition = 0
      // fontStyle = undefined,
      // fontSize = undefined
    ) {
      if (doc !== undefined) {
        doc.setFontSize(10);
        doc.text(text, widthPosition, heightPosition, { align: "center" });
      }
    },


  },
  mounted() {
    //   list
    // customerAPI.getList().then((response) => {
    //   this.customer_list = response.data.data;
    // });

    customerAPI.getList().then((response) => {
      this.customer_list = [
        ...response?.data?.data?.map((e) => {
          return { ...e, text: `${e.name} (${e.customer_id})` };
        }),
      ];
    });

    // invoice list
    invoiceAPI.invoiceList().then((response) => {
      this.invoice_list = response.data.data.filter((e) => e.customer_id == this.customer_id && e);
    });
  },
};
</script>

<style scoped>
.btn {
  margin: 5px;
}

th {
  text-align: center !important;
}
</style>
